module.exports = __webpack_public_path__ + "img/sttrp.1668abf7.png";